
































import CollectionSharedFunctions from '../CollectionSharedFunctions'
import Component from 'vue-class-component'
import DateTimeLabel from '@/components/labels/DateTimeLabel.vue'
import TextArea from '@/components/inputs/TextArea.vue'
import { Debounce } from 'vue-debounce-decorator'

@Component({
  components: { TextArea, DateTimeLabel }
})
export default class CollectionResident extends CollectionSharedFunctions {
  async updateResidentMemo (value: string) {
    this.selectedTask.resident['memo'] = value
    await this.debounceUpdate('memo', value)
  }
}
